import { LocationDTO } from '@sales-center/common'
import { ILeadOppProduct } from '@user/store/leadOppProducts'
import { aggregateServicesByLocationId } from '@user/store/serviceProducts'

export function getNextSortOrderByLocation(
  localMode: boolean,
  locations: LocationDTO[],
  services: ILeadOppProduct[],
) {
  const map = new Map<string, number>(
    locations.map<[string, number]>((location) => [
      // users can be on team in multiple places, ids must be unique
      localMode ? location.externalLinkId ?? '' : location.id.toString(),
      services.filter((x) =>
        localMode
          ? x.externalId == location.externalLinkId
          : x.serviceLocationId == location.id.toString(),
      ).length == 0
        ? 0
        : Math.max(
            ...aggregateServicesByLocationId(
              localMode
                ? location.externalLinkId ?? ''
                : location.id.toString(),
              services,
            ).map((o) => o.sortOrder),
          ) + 1,
    ]),
  )

  return map
}
